import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { IntlProvider } from 'react-intl'
import IntlContainer from './IntlContainer'

/**
 * Create an IntlProvider for the current selected locale
 */
class I18n extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
  }

  render() {
    const {
      children,
      className,
      messages,
      orgSettings: { locale }
    } = this.props

    return (
      <IntlProvider locale={locale} messages={messages}>
        <div className={className}>
          {children}
        </div>
      </IntlProvider>
    )
  }
}

export default IntlContainer(I18n)



// WEBPACK FOOTER //
// ./src/scripts/components/I18n/index.js